import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();

  const languageOptions = [
    { value: 'en', alt: t('language.english'), flagSrc: 'https://flagcdn.com/w20/us.png' },
    { value: 'es', alt: t('language.spanish'), flagSrc: 'https://flagcdn.com/w20/es.png' },
    { value: 'el', alt: t('language.greek'), flagSrc: 'https://flagcdn.com/w20/gr.png' }
  ];

  const selectedLanguage = languageOptions.find((option) => option.value === i18n.language) || languageOptions[0];

  return (
    <FormControl size="small" sx={{ minWidth: 64, mx: 1 }}>
      <Select
        value={selectedLanguage.value}
        onChange={(event) => i18n.changeLanguage(event.target.value)}
        displayEmpty
        aria-label={t('language.label')}
        sx={{ bgcolor: 'grey.100' }}
        renderValue={() => (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              py: 0.5
            }}
          >
            <Box
              component="img"
              src={selectedLanguage.flagSrc}
              alt={selectedLanguage.alt}
              sx={{ width: 22, height: 'auto', display: 'block', borderRadius: 0.5 }}
            />
          </Box>
        )}
      >
        {languageOptions.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            aria-label={option.alt}
            sx={{ justifyContent: 'center', py: 0.5 }}
          >
            <Box
              component="img"
              src={option.flagSrc}
              alt={option.alt}
              sx={{ width: 22, height: 'auto', display: 'block', borderRadius: 0.5 }}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
